import React, {
  useState,
  useEffect,
  useCallback,
  MouseEvent,
  ChangeEvent,
} from 'react';

import { makeStyles, createStyles } from '@material-ui/core/styles';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import IconButton from '@material-ui/core/IconButton';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import MoreVertIcon from '@material-ui/icons/MoreVert';

import { FiCamera } from 'react-icons/fi';
import { FaRegEdit } from 'react-icons/fa';

import Modal from '@material-ui/core/Modal';
import Backdrop from '@material-ui/core/Backdrop';
import Fade from '@material-ui/core/Fade';
import DeleteProduct from './DeleteProduct';
import EditProdutoSimples from '../Drawers/Produtos/Edit/EditProdutoSimples';
import CloneProdutoSimples from '../Drawers/Produtos/Clone/ProdutoSimples';

import { useToast } from '../../../../hooks/toast';
// import { useEditProduto } from '../../../../hooks/editProduto';

import api from '../../../../services/api';
import no_image from '../../../../assets/no_image.png';

import {
  ItemWrapper,
  SimpleTableText,
  InputWrapper,
  StatusSaleButton,
  ActionsOptionsButton,
  ModalImgWrapper,
  NewImg,
} from '../styles';

interface TableRowProdutoSimplesProps {
  grupo_produto_id: number;
  produto_id: number;
  descricao: string;
  estoque_atual: number;
  preco: number;
  pausar_venda: boolean;
  tipo_produto: number;
  grupo_id: number;
  unidade_medida_id: number;
  imagem: string;
  codigo: string;
  grupo_descricao: string;
}

const useStyles = makeStyles(() =>
  createStyles({
    modal: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
    itemCell: {
      maxWidth: '15vw',
    },
    estoqueCell: {
      maxWidth: '6vw',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
    },
  }),
);

const ITEM_HEIGHT = 48;

const TableRowProdutoSimples: React.FC<TableRowProdutoSimplesProps> = ({
  grupo_produto_id,
  produto_id,
  descricao,
  estoque_atual,
  preco,
  pausar_venda,
  tipo_produto,
  grupo_id,
  unidade_medida_id,
  grupo_descricao,
  imagem,
  codigo,
}) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [modalOpen, setModalOpen] = useState(false);
  const [vendaPausada, setVendaPausada] = useState(pausar_venda);
  const [siglaUnidade, setSigleUnidade] = useState('');
  const [produtoImg, setProdutoImg] = useState(imagem);

  useEffect(() => {
    async function loadUnidade(): Promise<void> {
      const response = await api.get(`/unidade_medida/${unidade_medida_id}`);

      setSigleUnidade(response.data.sigla);
    }

    loadUnidade();
  }, []);

  const open = Boolean(anchorEl);
  const classes = useStyles();

  const { addToast } = useToast();

  const handleSetPaused = useCallback(
    (data: { value: boolean; nome_produto: string }) => {
      try {
        const { value, nome_produto } = data;

        api
          .put(`/produto/${produto_id}`, { pausar_venda: value })
          .then((response) => {
            const { pausar_venda } = response.data;

            addToast({
              type: 'info',
              title: `Produto ${nome_produto} ${
                pausar_venda ? 'desativado' : 'ativado'
              }.`,
            });

            setVendaPausada(pausar_venda);
          });
      } catch (err) {
        const { message } = err.response.data;

        addToast({
          type: 'error',
          title: message,
        });
      }
    },
    [addToast, produto_id],
  );

  const handleModalOpen = (): void => {
    setModalOpen(true);
  };

  const handleModalClose = (): void => {
    setModalOpen(false);
  };

  const handleClick = useCallback((event: MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  }, []);

  const handleClose = useCallback(() => {
    setAnchorEl(null);
  }, []);

  const handleImageChange = useCallback(
    (e: ChangeEvent<HTMLInputElement>) => {
      if (e.target.files) {
        const data = new FormData();
        data.append('produto_img', e.target.files[0]);

        api.patch(`/produto/${produto_id}`, data).then((response) => {
          setProdutoImg(response.data.imagem);

          addToast({
            type: 'success',
            title: 'Imagem do produto atualizada',
          });
        });
      }
    },
    [produto_id, addToast],
  );

  return (
    <TableRow>
      <TableCell component="th" scope="row" className={classes.itemCell}>
        <ItemWrapper
          img_url={
            produtoImg
              ? `${process.env.REACT_APP_SERVER_URL}/files/${produtoImg}`
              : `${no_image}`
          }
        >
          <button type="button" onClick={handleModalOpen}>
            <FiCamera size={17} />
          </button>
          <span title={descricao}>{descricao}</span>
        </ItemWrapper>
      </TableCell>

      <TableCell align="center" className={classes.estoqueCell}>
        <SimpleTableText>{codigo ? `${codigo}` : 'Sem código'}</SimpleTableText>
      </TableCell>

      <TableCell align="center" className={classes.estoqueCell}>
        <SimpleTableText>
          {estoque_atual ? `${estoque_atual} ${siglaUnidade}` : 'Sem estoque'}
        </SimpleTableText>
      </TableCell>

      <TableCell align="center">
        <InputWrapper>
          <span>
            <b>R$ {preco}</b>
          </span>
        </InputWrapper>
      </TableCell>

      <TableCell align="center">
        <StatusSaleButton
          type="button"
          isPaused={!vendaPausada}
          className="paused"
          onClick={() =>
            handleSetPaused({
              value: true,
              nome_produto: descricao,
            })
          }
        >
          Pausado
        </StatusSaleButton>

        <StatusSaleButton
          type="button"
          isPaused={vendaPausada}
          className="activated"
          onClick={() =>
            handleSetPaused({
              value: false,
              nome_produto: descricao,
            })
          }
        >
          Ativado
        </StatusSaleButton>
      </TableCell>

      <TableCell>
        <ActionsOptionsButton>
          <div>
            <IconButton
              aria-label="more"
              aria-controls="options-menu"
              aria-haspopup="true"
              onClick={handleClick}
            >
              <MoreVertIcon />
            </IconButton>
            <Menu
              id="options-menu"
              anchorEl={anchorEl}
              keepMounted
              open={open}
              onClose={handleClose}
              PaperProps={{
                style: {
                  maxHeight: ITEM_HEIGHT * 4.5,
                  width: '20ch',
                },
              }}
            >
              <MenuItem onClick={handleClose}>
                <EditProdutoSimples
                  grupo_produto_id={grupo_produto_id}
                  produto_id={produto_id}
                  tipo_produto={tipo_produto}
                  descricao={descricao}
                  grupo_id={grupo_id}
                  unidade_medida_id={unidade_medida_id}
                />
              </MenuItem>
              <MenuItem onClick={handleClose}>
                <CloneProdutoSimples
                  grupo_produto_id={grupo_produto_id}
                  produto_id={produto_id}
                  tipo_produto={tipo_produto}
                  grupo_descricao={grupo_descricao}
                  grupo_id={grupo_id}
                  unidade_medida_id={unidade_medida_id}
                />
              </MenuItem>
              <MenuItem onClick={handleClose}>
                <DeleteProduct
                  produto_id={produto_id}
                  descricao={descricao}
                  tipo_produto={tipo_produto}
                />
              </MenuItem>
            </Menu>
          </div>
        </ActionsOptionsButton>
      </TableCell>

      <Modal
        className={classes.modal}
        open={modalOpen}
        onClose={handleModalClose}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Fade in={modalOpen}>
          <ModalImgWrapper>
            <div className="img_wrapper">
              <img
                src={
                  produtoImg
                    ? `${process.env.REACT_APP_SERVER_URL}/files/${produtoImg}`
                    : `${no_image}`
                }
              />
            </div>

            <div className="divider" />

            <div className="action">
              <NewImg>
                <label htmlFor="change_img">
                  <FaRegEdit size={24} />
                  <input
                    type="file"
                    id="change_img"
                    onChange={handleImageChange}
                  />
                </label>
              </NewImg>
            </div>
          </ModalImgWrapper>
        </Fade>
      </Modal>
    </TableRow>
  );
};

export default TableRowProdutoSimples;
